// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1qGLz","name":"ConsentHeader_name__3ULcQ","birthday":"ConsentHeader_birthday__CIHJN","skeleton":"ConsentHeader_skeleton__1zsx6"};